export const ClipboardOptions = {
  enabled: true,
  copyHeaders: false,
  copyFormatters: true,
  separator: '\t'
};
